import easyToUseImg from "../../images/easy-to-use.jpg";
import balloonsImg from "../../images/balloons.jpg";
import openSourceImg from "../../images/github-open-source.png";

export const featuresData = [
  {
    img: easyToUseImg,
    alt: 'easy-to-use',
    name: 'Easy to use',
    desc:
      ' A simple extension to discover which params were sent to Analytics',
  },
  {
    img: balloonsImg,
    alt: 'light',
    name: 'Light',
    desc:
      ' A light extension with no impacts on browser performance',
  },
  {
    img: openSourceImg,
    alt: 'free',
    name: 'Free',
    desc:
      ' Free extension with open-source code hosted on GitHub',
  }
];
